import { render, staticRenderFns } from "./handleJxps.vue?vue&type=template&id=69badf0f&scoped=true&"
import script from "./handleJxps.vue?vue&type=script&lang=js&"
export * from "./handleJxps.vue?vue&type=script&lang=js&"
import style0 from "./handleJxps.vue?vue&type=style&index=0&id=69badf0f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69badf0f",
  null
  
)

export default component.exports